export const TEAOR_TO_INDUSTRY = {
  '01': 'agriculture',
  '02': 'agriculture',
  '03': 'agriculture',
  '05': 'other',
  '06': 'other',
  '07': 'other',
  '08': 'other',
  '09': 'manufacturing',
  '10': 'manufacturing',
  '11': 'manufacturing',
  '12': 'manufacturing',
  '13': 'manufacturing',
  '14': 'manufacturing',
  '15': 'manufacturing',
  '16': 'manufacturing',
  '17': 'manufacturing',
  '18': 'manufacturing',
  '19': 'manufacturing',
  '20': 'manufacturing',
  '21': 'manufacturing',
  '22': 'manufacturing',
  '23': 'manufacturing',
  '24': 'manufacturing',
  '25': 'other',
  '26': 'manufacturing',
  '27': 'manufacturing',
  '28': 'manufacturing',
  '29': 'manufacturing',
  '30': 'manufacturing',
  '31': 'manufacturing',
  '32': 'manufacturing',
  '33': 'otherservices',
  '35': 'other',
  '36': 'other',
  '37': 'other',
  '38': 'other',
  '39': 'other',
  '41': 'construction',
  '42': 'construction',
  '43': 'construction',
  // Wholesale and retail trade and repair of motor vehicles (45.*)
  '4511': 'retail',
  '4519': 'retail',
  '4531': 'wholesale',
  '4532': 'retail',
  '46': 'wholesale',
  '47': 'retail',
  '4791': 'etrade',
  '49': 'logistics',
  '50': 'logistics',
  '51': 'logistics',
  '52': 'logistics',
  '53': 'courier',
  '55': 'travel',
  '56': 'travel',
  '58': 'otherservices',
  '59': 'otherservices',
  '60': 'otherservices',
  '61': 'otherservices',
  '62': 'otherservices',
  '63': 'it',
  '64': 'finance',
  '65': 'finance',
  '66': 'finance',
  '68': 'realestate',
  '69': 'otherservices',
  '691': 'lawyer',
  '70': 'consultancy',
  '71': 'engineer',
  '72': 'other',
  '73': 'otherservices',
  '74': 'other',
  '75': 'medicine',
  '77': 'other',
  '78': 'other',
  '79': 'travel',
  '80': 'other',
  '81': 'construction',
  '82': 'otherservices',
  '84': 'other',
  '85': 'education',
  '86': 'medicine',
  '87': 'otherservices',
  '88': 'otherservices',
  '90': 'art',
  '91': 'other',
  '92': 'other',
  '93': 'sport',
  '94': 'other',
  '95': 'vehicle',
  '96': 'otherservices',
  '97': 'other',
  '98': 'other',
  '99': 'other',
};

export const getIndustrySlugForCodePrefix = (
  codePrefix,
) => {
  if (codePrefix === undefined || codePrefix === null) return undefined;
  const digits = String(codePrefix).replace(/\D/g, '');
  if (!digits) return undefined;
  const key4 = digits.length >= 4 ? digits.slice(0, 4) : undefined;
  if (key4 && TEAOR_TO_INDUSTRY[key4]) return TEAOR_TO_INDUSTRY[key4];
  const key3 = digits.length >= 3 ? digits.slice(0, 3) : undefined;
  if (key3 && TEAOR_TO_INDUSTRY[key3]) return TEAOR_TO_INDUSTRY[key3];
  const key2 = digits.padStart(2, '0').slice(0, 2);
  return TEAOR_TO_INDUSTRY[key2];
};
